import * as React from 'react'
import { Check } from 'lucide-react'
import { cn } from '@/utils/cn'

export interface StepperStep {
  id: string
  label: string
}

export interface StepperProps {
  steps: StepperStep[]
  currentStep: number
  className?: string
}

function Stepper({ steps, currentStep, className }: StepperProps) {
  return (
    <div className={cn('flex items-start justify-center', className)}>
      {steps.map((step, index) => {
        const isCompleted = index < currentStep
        const isCurrent = index === currentStep
        const isLast = index === steps.length - 1

        return (
          <React.Fragment key={step.id}>
            {/* Step with circle and label */}
            <div className="flex flex-col items-center">
              {/* Step circle */}
              <div
                className={cn(
                  'flex h-10 w-10 items-center justify-center rounded-full text-sm font-semibold transition-all',
                  isCurrent &&
                    'bg-primary text-white shadow-[0_0_0_4px_var(--color-primary-glow)]',
                  isCompleted &&
                    'bg-primary text-white shadow-[0_0_0_4px_var(--color-primary-glow)]',
                  !isCompleted &&
                    !isCurrent &&
                    'bg-[#F8F8F8] border border-[#D6DAE1] text-[#D6DAE1]'
                )}
              >
                {isCompleted ? (
                  <Check className="h-5 w-5" />
                ) : (
                  <span>{index + 1}</span>
                )}
              </div>

              {/* Step label - centered under circle */}
              <span
                className={cn(
                  'mt-2 text-xs font-bold transition-colors whitespace-nowrap',
                  (isCurrent || isCompleted) && 'text-primary',
                  !isCurrent && !isCompleted && 'text-[#D6DAE1]'
                )}
              >
                {step.label}
              </span>
            </div>

            {/* Connector line between steps - aligned with circle center */}
            {!isLast && (
              <div
                className={cn('h-[2px] w-[100px] mx-2 mt-5', 'bg-[#D6DAE1]')}
              />
            )}
          </React.Fragment>
        )
      })}
    </div>
  )
}

export { Stepper }
